import React from 'react';
import {Dimensions, StyleSheet, View} from 'react-native';

const StepIndicator = ({currentStep, totalSteps}) => {
    const screenWidth = Dimensions.get('window').width;
    const horizontalPadding = screenWidth >= 1200 ? 100 : 24;
    const totalGapWidth = Math.max(totalSteps - 1, 0) * 2;
    const availableWidth = screenWidth - horizontalPadding * 2 - totalGapWidth;
    const segmentWidth = availableWidth / totalSteps;

    const stepList = Array.from({length: totalSteps}, (_, index) => index);

    return (
        <View style={styles.container}>
            {stepList.map((_, index) => (
                <View
                    key={`step-indicator-${index}`}
                    style={[
                        styles.segment,
                        {
                            width: segmentWidth,
                            backgroundColor: index <= currentStep ? '#000' : '#fff',
                        },
                        index !== 0 && styles.segmentMargin,
                        index < totalSteps - 1 && styles.segmentSpace,
                    ]}
                />
            ))}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        marginBottom: 25,
        marginTop: 50,
        marginHorizontal: Dimensions.get('window').width >= 1200 ? 100 : 24,
    },
    segment: {
        height: 10,
        backgroundColor: '#fff',
    },
    segmentMargin: {
        marginLeft: 1,
    },
    segmentSpace: {
        marginRight: 1,
    },
});

export default StepIndicator;
